
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true,\"url\":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-00ef570c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./SubmissionCategoryDialog.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./SubmissionCategoryDialog.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-00ef570c\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SubmissionCategoryDialog.vue"),
  /* scopeId */
  "data-v-00ef570c",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/developerInfo/components/SubmissionCategoryDialog.vue
// module id = 2400
// module chunks = 68